<div class="container-fluid mt-4">
  <h4 class="mb-3"><i class="fi fi-rr-house-chimney"></i> მთავარი გვერდი </h4>
    <div class="row g-4">

      <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>
      
      <app-error  *ngIf="!load && error" [title]="'შეცდომა ჩატვირთვის დროს'" (reload)="get()"></app-error>

      <div class="position-relative">

        <div *ngIf="!load" cdkDropList (cdkDropListDropped)="drop($event)">
          <div *ngFor="let item of data" cdkDrag class="card p-2 mb-2 shadow-sm">
            <div class="d-flex justify-content-between align-items-center">
              <div>

                <span *ngIf="item.tmp == 'items'">
                  {{item.page.title}}
                </span>

                <span *ngIf="item.tmp == 'slider'">
                  სლაიდი
                </span>

                <span *ngIf="item.tmp == 'cover'">
                  ქოვერი: {{ item.items[0].title }}
                </span>
                
              </div>
              <div class="d-flex">
                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="edit(item)"><i class="fi fi-rr-pencil"></i></button> 
                <button class="btn btn-sm text-danger border rounded d-flex align-items-center mx-2" (click)="destroy(item)"><i class="fi fi-rr-trash"></i></button> 
              </div>
            </div>
          </div>
        </div>

        
        <div class="load-blur" *ngIf="loadUpdate">
          <app-spinner [loading]="loadUpdate" text="იტვირთება..."></app-spinner>
        </div>
      </div>

      <div>
        <button type="button" class="btn btn-primary" (click)="add()">დამატება</button>
      </div>

    </div>
</div>

<ng-template #formModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <span *ngIf="isEdit">რედაქტირება</span>
      <span *ngIf="!isEdit">დამატება</span>
      <span *ngIf="selected?.tmp == 'items' && isEdit"> {{selected?.page?.title}} </span>
      <span *ngIf="selected?.tmp == 'slider' && isEdit"> სლაიდი</span>
      <span *ngIf="selected?.tmp == 'cover' && isEdit"> ქოვერი</span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">

      <form [formGroup]="form">

        <div class="form-floating mb-3" *ngIf="!isSlider || selected?.tmp !== 'slider'">
          <select formControlName="tmp" class="form-select" id="tmp" (change)="onChange()">
            <option value="slider" *ngIf="!isSlider"> სლაიდი</option>
            <option value="items"> პოსტები </option>
            <option value="cover"> ქოვერი </option>
          </select>
          <label for="tmp">მოდულის ტიპი</label>
          <div class="invalid-feedback">error</div>
        </div>

        <app-spinner *ngIf="!selecterror" [loading]="selectLoad"></app-spinner>
        <app-error *ngIf="selecterror" (reload)="onChange()"></app-error>
        <div *ngIf="!selectLoad">
          
          <div class="form-floating mb-3" *ngIf="form.get('tmp').value == 'items'">
            <select formControlName="data_id" class="form-select mb-3" id="source" >
              <option *ngFor="let itm of selectedItems" [ngValue]="itm.id">{{ itm.title }}</option>
            </select>
            <label for="source">აირჩიეთ პოსტები</label>
          </div>

          <div class="form-floating mb-3" *ngIf="form.get('tmp').value == 'cover'">
            <select formControlName="data_id" class="form-select mb-3" id="source">
              <option *ngFor="let itm of selectedPage" [ngValue]="itm.id">{{ itm.title }}</option>
            </select>
            <label for="source">აირჩიეთ გვერდი</label>
          </div>
        </div>
         
        <div class="input-group mb-3" *ngIf="form.get('tmp').value == 'cover'">
          <span class="input-group-text" id="basic-redirectlink">https:</span>
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              formControlName="redirect"
              id="redirect"
              placeholder=""
              required>
            <label for="redirect">გადამისამართების ბმული</label>
            <div class="invalid-feedback">
              error
            </div>
          </div>
        </div>

        <div class="input-group mb-3" *ngIf="form.get('tmp').value == 'cover'">
          <span class="input-group-text" id="redirect_en">https:</span>
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              formControlName="redirect_en"
              id="redirect_en"
              placeholder=""
              required>
            <label for="redirect_en">გადამისამართების ბმული (en)</label>
            <div class="invalid-feedback">
              error
            </div>
          </div>
        </div>

        <div *ngIf="form.get('tmp').value == 'items'" class="row">
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <input
                type="number"
                class="form-control"
                formControlName="items_limit"
                id="items_limit"
                placeholder="პოსტების ლიმიტი"
                required>
              <label for="items_limit">პოსტების ლიმიტი</label>
              <div class="invalid-feedback">
                error
              </div>
            </div>
          </div>
           
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <input
                type="number"
                class="form-control"
                formControlName="autoplay"
                id="autoplay"
                placeholder="ავტომატური გადასვლა"
                required>
              <label for="autoplay">ავტომატური გადასვლა</label>
              <div class="invalid-feedback">
                error
              </div>
            </div>
          </div>
          

        </div>

        <div class="col-md-6" *ngIf="form.get('tmp').value == 'slider'">
          <div class="form-floating mb-3">
            <input
              type="number"
              class="form-control"
              formControlName="autoplay"
              id="autoplay"
              placeholder="ავტომატური გადასვლა"
              required>
            <label for="autoplay">ავტომატური გადასვლა</label>
            <div class="invalid-feedback">
              error
            </div>
          </div>
        </div>

        <div class="form-check form-switch mb-3" *ngIf="form.get('tmp').value == 'cover'">
          <input type="checkbox" class="form-check-input" id="showtitle"
                [checked]="form.get('showtitle').value == 1"
                (change)="setCheckboxValue('showtitle', $any($event.target).checked)">
          <label class="form-check-label" for="showtitle">სათაურის გამოჩენა</label>
        </div>

        <div  *ngIf="form.get('showtitle').value">
          <div class="form-floating mb-3" *ngIf="form.get('tmp').value == 'cover'">
            <select id="title_position" formControlName="title_position" name="title_position" class="form-control">

              <option value="top-left">ზედა მარცხენა</option>
              <option value="top-center">ზედა ცენტრი</option>
              <option value="top-right">ზედა მარჯვენა</option>

              <option value="middle-left">შუა მარცხენა</option>
              <option value="middle-center">შუა ცენტრი</option>
              <option value="middle-right">შუა მარჯვენა</option>

              <option value="bottom-left">ქვედა მარცხენა</option>
              <option value="bottom-center">ქვედა ცენტრი</option>
              <option value="bottom-right">ქვედა მარჯვენა</option>
            </select>
            <label for="title_position">სათაურის პოზიცია</label>
          </div>
     
          <div class="form-check form-switch mb-3" *ngIf="form.get('tmp').value == 'cover'">
            <input type="checkbox" class="form-check-input" id="title_image"
                  [checked]="form.get('title_image').value == 1"
                  (change)="setCheckboxValue('title_image', $any($event.target).checked)">
            <label class="form-check-label" for="title_image">სათაური სურათზე</label>
          </div>
        </div>


        <div class="form-check form-switch mb-3" *ngIf="form.get('tmp').value == 'cover' || form.get('tmp').value == 'slider'">
          <input type="checkbox" class="form-check-input" id="border"
                [checked]="form.get('border').value == 1"
                (change)="setCheckboxValue('border', $any($event.target).checked)">
          <label class="form-check-label" for="border">ჩარჩოში გამოჩენა</label>
        </div>

        <div class="form-check form-switch mb-3" *ngIf="form.get('tmp').value == 'cover'">
          <input type="checkbox" class="form-check-input" id="new_window"
                [checked]="form.get('new_window').value == 1"
                (change)="setCheckboxValue('new_window', $any($event.target).checked)">
          <label class="form-check-label" for="new_window">ლინკის გახსნა ახალ ფანჯარაში</label>
        </div>
        <div class="form-check form-switch mb-3">
          <input type="checkbox" class="form-check-input" id="visibility"
                 [checked]="form.get('visibility').value"
                 (change)="setCheckboxValue('visibility', $any($event.target).checked)">
          <label class="form-check-label" for="visibility"> გამოჩენა</label>
        </div>

      </form>

  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
    <button class="btn btn-primary d-flex" (click)="save(modal)" [disabled]="editBtnLoad">
      <app-spinner [sm]="true" [loading]="editBtnLoad"></app-spinner> 
      <span *ngIf="isEdit">შენახვა</span>
      <span *ngIf="!isEdit">დამატება</span>
    </button>
  </div>
</ng-template>
